import { Link } from "react-router-dom";
import { LeaderboardBanner } from "./banner/Leaderboard-Banner";
import "./index.scss";
import { LeaderboardResults } from "./results/Leaderboard-Results";
import { LeaderboardRewards } from "./rewards/Leaderboard-Rewards";
import { useEffect, useState } from "react";

export enum LeaderboardBrand {
  CSGOROLL = "csgoroll",
  HYPEDROP = "hypedrop",
}
export interface LeaderboardProps {
  month: string;
  brand: LeaderboardBrand;
  from: string;
  to: string;
  lastPeriodTotalDeposit?: number;
  lastUpdate: string;
}

const brandOption = (brand: LeaderboardBrand) => {
  return (
    <div className="brand-option">
      <Link to={`/${brand}/leaderboard`}>
        <img
          src={`/assets/${brand.toLowerCase()}-logo.png`}
          alt={`${brand} logo`}
        />
      </Link>
    </div>
  );
};

export const Leaderboard = (props: LeaderboardProps) => {
  // const promotionalAsset =
  //   props.brand === LeaderboardBrand.CSGOROLL ? "/assets/xmasstitle.png" : null;
  const promotionalAsset = null;
  const [total, setTotal] = useState<number>(0);
  useEffect(() => {
    import(
      `/src/leaderboard/results/data/${props.brand}/${props.month}.json`
    ).then((module) => {
      const data = module.default.data.affiliateEarningsByReferee.edges;
      const total = data
        .filter(
          (n: any) =>
            !n.node.statuses.includes("STOLEN") && n.node.commission > 0,
        )
        .reduce((acc: number, curr: any) => {
          return acc + parseFloat(curr.node.commission.toString());
        }, 0);
      setTotal(total);
    });
  }, [props.brand]);
  return (
    <>
      <div className="brand-options">
        {brandOption(LeaderboardBrand.CSGOROLL)}
        {/* {brandOption(LeaderboardBrand.HYPEDROP)} */}
      </div>
      <div className="leaderboard">
        <LeaderboardBanner
          brand={props.brand}
          promotionAsset={promotionalAsset}
          from={props.from}
          to={props.to}
        />

        {/* <Link to="/leaderboard_previous">See previous leaderboard results</Link> */}
        <LeaderboardResults {...props} timestamp={props.lastUpdate} />
      </div>
    </>
  );
};
